import { Avatar, mergeClassName } from '@chain-zen/ui'

import type { UserAvatarProps } from '../../../types/user'
import { userDisplayName } from '../../../utils/user'
import { UserInfoTooltip } from './user-info-tooltip'

export const UserAvatar = ({
  size = 'xs',
  user,
  showTooltip = true,
  workspace,
  showOnlineBadge = true,
  variant = 'basic'
}: UserAvatarProps) => {
  const displayName = userDisplayName({
    email: user.email,
    name: user.name,
    phone: user.phone
  })

  return (
    <UserInfoTooltip showTooltip={showTooltip} user={user} workspace={workspace}>
      <div className="relative inline-block">
        <Avatar
          className={mergeClassName(variant === 'square' ? 'rounded-md' : 'rounded-full')}
          src={user?.photo || ''}
          alt={displayName}
          name={displayName}
          size={size}
        />
        {!!user?.online && !!showOnlineBadge && (
          <span className="absolute bottom-0 right-0 block h-2 w-2 rounded-full bg-green-500 ring-2 ring-white" />
        )}
      </div>
    </UserInfoTooltip>
  )
}
